type AnalyticsEvent = {
  name: string;
  props?: Record<string, any>;
};

export function track({ name, props }: AnalyticsEvent) {
  try {
    if ((window as any).plausible) {
      (window as any).plausible(name, { props });
    } else if ((window as any).gtag) {
      (window as any).gtag('event', name, props || {});
    } else {
      // Fallback: console for development
      console.debug('[analytics]', name, props || {});
    }
  } catch (e) {
    // never throw from analytics
  }
}


